import * as React from 'react';
import DashboardLayout from '../Layouts/DashboardLayout';
import { CalculatorBg } from '../../components/Calculator/CalculatorUI';

const Calculator: React.SFC = () => (
  <DashboardLayout>
    <CalculatorBg>Calculator</CalculatorBg>
  </DashboardLayout>
);

export default Calculator;



// WEBPACK FOOTER //
// ./src/containers/Calculator/Calculator.tsx